<template>
    <div class="w-full bg-white bg-custom">
        <Menubar class="w-full tablet:w-9/12 mx-auto bg-custom" :model="items">
            <template #start>
                <Logo />
            </template>
            <template #item="{ item, props }">
                <a class="flex items-center" v-bind="props.action"
                    @click="item.command ? item.command() : makeRedirect(item.path)">
                    <span :class="{ 'active-item': item.path === $route.path }">
                        {{ item.label }}
                    </span> </a>
            </template>
        </Menubar>
    </div>
</template>

<script>
import { Badge, Menubar } from 'primevue';
import Logo from './Logo.vue';

export default {
    name: 'Navbar',
    components: {
        Menubar,
        Logo,
        Badge
    },
    methods: {
        makeLogout() {
            this.$store.dispatch('makeLogout');
            this.makeRedirect('/login');
        }
    },
    computed: {
        items() {
            const adminMenu = [
                { label: 'Agendas', path: '/admin' },
                { label: 'Gestão', path: '/admin/gestao', adminOnly: true },
                { label: 'Logs', path: '/admin/gestao/logs' },
                { label: 'Usuários', path: '/admin/usuarios' },
                { label: 'Financeiro', path: '/admin/financeiro' }
            ];

            const userMenu = [
                { label: 'Agenda', path: '/user' },
                { label: 'Reservas', path: '/user/agendas' },
                { label: 'Salas', path: '/user/salas' }
            ];

            const logoutItem = {
                label: 'Sair',
                command: () => this.makeLogout()
            };

            const accessLevel = this.$store.state.accessLevel;
            return (['admin', 'secretary'].includes(accessLevel) ? adminMenu.filter(item => !item.adminOnly || accessLevel === 'admin') : userMenu).concat(logoutItem);
        }
    },
}
</script>

<style scoped>
:deep(.p-menubar-item.p-focus .p-menubar-item-link) {
    background-color: #f9f6eb !important;
}

:deep(.p-menubar-item:hover .p-menubar-item-link) {
    background-color: #f9f6eb !important;
}

:deep(.p-menubar-item:active .p-menubar-item-link) {
    background-color: #f9f6eb !important;
}

.p-menubar {
    border: none;
    border-radius: none;

    flex-direction: row;
    justify-content: space-between;
}

.active-item {
    border-bottom: 2px solid #0d141a;
}

@media (max-width: 640px) {
    .p-menubar {
        padding: 8px 2rem;
    }
}
</style>